<template>
  <v-sheet height="100%">
    <LoadingWidget v-if="loading" />
    <transition name="fade">
      <v-container v-if="!loading" class="pt-6 pb-6 pb-md-10 pt-md-12">
        <v-row justify="center">
          <v-col cols="12" md="10">
            <div class="font-weight-bold text-h5 text-sm-h4">
              {{ article.title }}
            </div>
            <div class="d-flex justify-space-between pt-5 align-center">
              <div class="d-flex align-baseline">
                <v-icon color="grey lighten-3" size="16" class="align-baseline">
                  far fa-calendar
                </v-icon>
                <span
                  class="
                    ml-2
                    font-weight-regular
                    grey--text
                    text--lighten-3 text-body-2 text-sm-body-1
                  "
                >
                  {{ formatDate(article.createdAt, "long") }}
                </span>
              </div>
              <ShareLinksWidget />
            </div>
            <img
              v-if="image"
              class="d-block mt-6 mt-md-8 item-img"
              :src="image + '?resize=1&w=960'"
              :alt="article.title"
              width="100%"
            />

            <div
              v-if="article.text"
              class="mt-6 mt-md-8 ck-content item-text"
              v-html="article.text"
            ></div>

            <div v-if="images.length && images.length > 1" class="mt-12">
              <TitleWidget class="text-center" small>
                <span class="text-h6 text-sm-h5 text-md-h4 font-weight-bold">
                  Galeria de Fotos</span
                >
              </TitleWidget>

              <CoolLightBox
                :items="images"
                :index="index"
                @close="index = null"
              />

              <div class="mt-6 mt-md-8 images-grid-list">
                <img
                  class="d-block cursor-pointer"
                  @click="index = keyImages"
                  :src="img + '?resize=1&w=300'"
                  width="100%"
                  v-for="(img, keyImages) in images"
                  :key="keyImages"
                />
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </transition>
  </v-sheet>
</template>

<script>
import LoadingWidget from "../components/widgets/LoadingWidget.vue";
import CoolLightBox from "vue-cool-lightbox";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";
import TitleWidget from "../components/widgets/TitleWidget.vue";
import ShareLinksWidget from "../components/widgets/ShareLinksWidget.vue";
import { formatDate } from "../utils/formatDate";

const _config = {
  mod: "articles",
};
export default {
  data: () => ({
    loading: true,
    article: {},
    index: null,
  }),
  computed: {
    itemId() {
      return this.$route.params.item.replace(/^.*-([0-9]+)$/, "$1");
    },
    image() {
      return this.article.img &&
        this.article.img.featured &&
        this.article.img.featured.path
        ? this.files + this.article.img.featured.path
        : "";
    },
    images() {
      const images = [];
      if (
        this.article.img &&
        this.article.img.list &&
        this.article.img.list.length
      )
        this.article.img.list.map(({ path }) => {
          if (path != this.image) images.push(this.files + path);
        });
      return images;
    },
  },
  methods: {
    formatDate,
    getArticle() {
      const params = {
        id: this.itemId,
      };
      this.$rest(_config.mod)
        .get(params)
        .then((data) => {
          this.article = data;
        })
        .catch(() => this.$router.replace("/error404"))
        .finally(() => (this.loading = false));
    },
  },
  created() {
    this.getArticle();
  },
  watch: {
    itemId() {
      this.getArticle();
    },
  },
  components: { LoadingWidget, CoolLightBox, TitleWidget, ShareLinksWidget },
};
</script>

<style lang="scss" scoped>
.images-grid-list {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(4, 1fr);
  @media screen and (max-width: 960px) {
    gap: 5px;
    grid-template-columns: repeat(3, 1fr);
  }
  @media screen and (max-width: 600px) {
    grid-template-columns: repeat(2, 1fr);
  }
  img {
    aspect-ratio: 16 / 12;
    -o-object-fit: cover;
    object-fit: cover;
  }
}
</style>
